import { getStorage, loginStore, setStorage } from "@/modules/login/store";
import { formatToDawn } from "@/utils/format-time";
import {
  Box,
  Button,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  Text,
  useBoolean,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";

export const DistributeFreeCoinModal = observer(() => {
  const [open, setOpen] = useBoolean(false);
  useEffect(() => {
    if (loginStore.isGuest) return;
    const expire = getStorage("distributeExpire");
    if (!expire || Date.now() > Number(expire)) {
      setOpen.on();
      setStorage("distributeExpire", String(formatToDawn(new Date(), 1)));
    }
  }, []);
  return (
    <Modal isOpen={open} onClose={setOpen.off} isCentered>
      <ModalContent w="400px" h="500px" bg="bg.panelBg" color="white">
        <ModalCloseButton />
        <ModalBody display="flex" flexDir="column" alignItems="center" p="0 35px">
          <Text fontSize="24px" mt="48px" fontWeight={600}>
            欢迎回到「画宇宙」
          </Text>
          <Box h="142px" my="44px">
            <Image h="100%" src="http://nolipix-js.nolibox.com/assets/creator/congratulation.png" />
          </Box>
          <Text fontSize="18px" mb="14px">
            今日登录，已为您赠送 30 免费画力星⭐
          </Text>
          <Text fontSize="14px" color="text.subtitle">
            赠送的免费画力星可用于画宇宙系列模型功能
          </Text>
          <Button w="212px" h="38px" mt="52px" fontSize="14px" onClick={setOpen.off}>
            确认
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
});
